module.exports = __webpack_public_path__ + "img/cef.a6305ea2.png";